module.exports = __webpack_public_path__ + "static/media/Laughing.ffe49167.jpg";